import React from 'react';
import './Vinculacion.css';

export default function Vinculacion() {
  return (
    <div className="vinc-page">
      <div className="vinc-container">

        {/* HERO */}
        <div className="vinc-hero">
          <div className="vinc-hero-icon">📱</div>
          <h1>MonkeyPhone</h1>
          <p>Registra tu número en el padrón nacional para activar tu servicio correctamente.</p>
        </div>

        {/* ALERTA WIFI */}
        <div className="vinc-alert">
          <div className="vinc-alert-icon">📶</div>
          <div>
            <strong>Importante: Conéctate a una red WiFi</strong>
            <p>El registro debe hacerse conectado a WiFi. Si no tienes saldo o datos disponibles, busca una red WiFi para completar el proceso.</p>
          </div>
        </div>

        {/* PASOS */}
        <div className="vinc-steps">
          <h2>¿Cómo vincular tu línea?</h2>

          <div className="vinc-step">
            <div className="vinc-step-num">1</div>
            <div className="vinc-step-content">
              <h3>Conéctate a WiFi</h3>
              <p>Asegúrate de estar conectado a una red WiFi antes de iniciar el registro. Esto es necesario porque tu línea puede no tener datos activos aún.</p>
            </div>
          </div>

          <div className="vinc-step">
            <div className="vinc-step-num">2</div>
            <div className="vinc-step-content">
              <h3>Ingresa al portal de registro</h3>
              <p>Haz clic en el botón de abajo para ir al portal oficial de vinculación.</p>
            </div>
          </div>

          <div className="vinc-step">
            <div className="vinc-step-num">3</div>
            <div className="vinc-step-content">
              <h3>Completa tus datos</h3>
              <p>Ingresa tu número de teléfono MonkeyPhone (10 dígitos), tu CURP o identificación oficial, y sigue las instrucciones en pantalla.</p>
            </div>
          </div>

          <div className="vinc-step">
            <div className="vinc-step-num">4</div>
            <div className="vinc-step-content">
              <h3>¡Listo!</h3>
              <p>Una vez completado el registro, tu línea estará vinculada y lista para usar todos los servicios.</p>
            </div>
          </div>
        </div>

        {/* BOTÓN PRINCIPAL */}
        <a
          href="https://rnu.altanredes.com/addomv/vinculatulinea"
          target="_blank"
          rel="noopener noreferrer"
          className="vinc-btn-primary"
        >
          📲 Ir al Portal de Vinculación
        </a>

        {/* FAQ */}
        <div className="vinc-faq">
          <h2>Preguntas Frecuentes</h2>

          <div className="vinc-faq-item">
            <h3>¿Por qué necesito WiFi?</h3>
            <p>Si acabas de activar tu línea o no tienes saldo, necesitas una conexión a internet para acceder al portal de registro. El WiFi te permite hacerlo sin gastar datos.</p>
          </div>

          <div className="vinc-faq-item">
            <h3>¿Qué pasa si no me registro?</h3>
            <p>El registro es obligatorio por ley. Sin vinculación, tu línea podría ser suspendida después de un tiempo.</p>
          </div>

          <div className="vinc-faq-item">
            <h3>¿Qué datos necesito?</h3>
            <p>Tu número MonkeyPhone de 10 dígitos y una identificación oficial (INE/IFE) o CURP.</p>
          </div>

          <div className="vinc-faq-item">
            <h3>¿Cuánto tarda el proceso?</h3>
            <p>El registro toma menos de 5 minutos. Una vez completado, tu línea queda vinculada de forma inmediata.</p>
          </div>

          <div className="vinc-faq-item">
            <h3>¿Me quedé sin saldo, qué hago?</h3>
            <p>No te preocupes. Conéctate a cualquier red WiFi (casa, café, trabajo) y realiza el registro desde ahí. No necesitas datos móviles para este proceso.</p>
          </div>
        </div>

        {/* CONTACTO */}
        <div className="vinc-contact">
          <p>¿Necesitas ayuda? Contáctanos:</p>
          <div className="vinc-contact-options">
            <a href="https://app.monkeyfon.com/Mensajeria" className="vinc-contact-btn">💬 Chat</a>
            <a href="https://wa.me/5215586467130" target="_blank" rel="noopener noreferrer" className="vinc-contact-btn">📱 WhatsApp</a>
          </div>
        </div>

      </div>
    </div>
  );
}
